import { UserService } from "@/services/users/users.service";

export const useUserList = () => {
  const { data, error, isLoading, mutate } = UserService.getUserList();

  return { users: data, error, isLoading, mutate };
};
